import { defineComponent as n, reactive as f, ref as c, onMounted as d, watch as p, computed as u, createBlock as m, openBlock as v, withCtx as b, createElementVNode as _, renderSlot as D, createTextVNode as h, toDisplayString as y } from "vue";
import { _ as w } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
import { _ as k } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const x = /* @__PURE__ */ n({
  __name: "OverflowTooltip",
  props: {
    title: {
      type: String,
      default: ""
    },
    forceEnable: {
      type: Boolean,
      default: !1
    },
    forceDisable: {
      type: Boolean,
      default: !1
    }
  },
  setup(a) {
    const e = a, l = f({
      isDisable: !1
    }), t = c(null), o = () => {
      t.value && t.value.offsetWidth < t.value.scrollWidth ? l.isDisable = !1 : l.isDisable = !0;
    }, r = new ResizeObserver(() => {
      o();
    });
    d(() => {
      o(), r.observe(t.value);
    }), p(
      () => e.title,
      (s) => {
        o();
      }
    );
    const i = u(() => e.forceEnable ? !1 : e.forceDisable ? !0 : l.isDisable);
    return (s, B) => (v(), m(w, {
      class: "title-tooltip",
      content: !i.value && e.title ? e.title : "",
      delay: [1e3, 0]
    }, {
      default: b(() => [
        _("div", {
          class: "title-tooltip--name",
          ref_key: "nameRef",
          ref: t
        }, [
          D(s.$slots, "default", {}, () => [
            h(y(a.title), 1)
          ], !0)
        ], 512)
      ]),
      _: 3
    }, 8, ["content"]));
  }
}), O = /* @__PURE__ */ k(x, [["__scopeId", "data-v-fdeefff8"]]);
export {
  O as default
};
